import { createSelector } from 'reselect'

const getIsBackgroundCheckComplete = state => state.backgroundCheckComplete

const getPaymentAccountSetupComplete = state => state.paymentAccountSetupComplete

const hasScheduledDash = state => state.hasScheduledDash

const bofWaitlistExperiment = state => state.bofWaitlistExperiment

const isWebview = state => state.isWebview

export const showBoFWaitlistSelector = createSelector(
  isWebview,
  getIsBackgroundCheckComplete,
  getPaymentAccountSetupComplete,
  hasScheduledDash,
  bofWaitlistExperiment,
  (
    isWebview,
    backgroundCheckComplete,
    paymentAccountSetupComplete,
    hasScheduledDash,
    bofWaitlistExperiment,
  ) => {
    return (
      isWebview &&
      backgroundCheckComplete &&
      paymentAccountSetupComplete &&
      !hasScheduledDash &&
      bofWaitlistExperiment
    )
  }
)
